import axios                        from 'axios';
import store                        from '../';
import {router}                     from '../../router/router.js'
import {addItemUrl, apiDomain, SHOW_PRICES}     from '../../config';
import cloneDeep                    from 'lodash/cloneDeep';
import { functions } from '../../functions';
import * as perf from '../../perf';

function isPriceSort(option) {
    return !!(option && option.name && option.name.indexOf('Price:') === 0)
}

function defaultSortOption() {
    return SHOW_PRICES
        ? { id: 1, name: "Price: Low to High", chosen: true }
        : { id: 5, name: "Performance: High to Low", chosen: true }
}

function resolveSortOption(option) {
    if(option && option.name == 'Value: High to Low') {
        return { id: 3, name: "Perf/$: High to Low", chosen: true }
    }
    if(option && option.name == 'Value: Low to High') {
        return { id: 6, name: "Perf/$: Low to High", chosen: true }
    }
    if (!SHOW_PRICES && isPriceSort(option)) {
        return defaultSortOption()
    }
    return option || defaultSortOption()
}

function finiteNumber(value) {
    var number = parseFloat(value)
    return isNaN(number) || !isFinite(number) ? null : number
}

function partSortTitle(item) {
    return String((item && (item.model || item.title || item.asin)) || '').toLowerCase()
}

function scoreSortContext(items) {
    var ignoreBenchmark = perf.shouldIgnoreBenchmark(items)
    return {
        ignoreBenchmark: ignoreBenchmark,
        ceiling: perf.buildCeiling(items, { ignoreBenchmark: ignoreBenchmark }),
        valueCeiling: perf.buildValueCeiling(items, { ignoreBenchmark: ignoreBenchmark })
    }
}

function performanceSortValue(item, context) {
    var stored = finiteNumber(item && item.performance)
    if(stored !== null) {
        return stored
    }
    var cap = perf.rawCapacity(item, { ignoreBenchmark: context.ignoreBenchmark })
    return cap ? perf.normalizedScore(cap.raw, context.ceiling) : null
}

function valueSortValue(item, context) {
    var stored = finiteNumber(item && item.valueIndex)
    if(stored !== null) {
        return stored
    }
    return perf.valueIndex(item, context.valueCeiling, { ignoreBenchmark: context.ignoreBenchmark })
}

function compareNullableNumbers(left, right, direction) {
    if(left === null && right === null) {
        return 0
    }
    if(left === null) {
        return 1
    }
    if(right === null) {
        return -1
    }
    return direction == 'asc' ? left - right : right - left
}

function compareByMetric(left, right, accessor, direction) {
    var result = compareNullableNumbers(accessor(left), accessor(right), direction)
    return result || partSortTitle(left).localeCompare(partSortTitle(right))
}

const catalogMetadataFields = [
    'features',
    'slug',
    'is_available',
    'availability_status',
    'availability_reason',
    'release_date',
    'release_date_precision',
    'release_date_confidence',
    'release_date_source_name',
    'release_date_source_url',
    'release_date_note',
    'upc',
    'upc_confidence',
    'upc_source_name',
    'upc_source_url'
]

function generalFields(fields) {
    return fields.concat(catalogMetadataFields)
}

function parsedImageList(value) {
    if(Array.isArray(value)) {
        return value.filter((entry) => typeof entry === 'string' && entry.trim())
    }
    if(typeof value !== 'string' || !value.trim() || value.trim().toLowerCase() === 'n/a') {
        return []
    }
    try {
        var parsed = JSON.parse(value)
        return Array.isArray(parsed)
            ? parsed.filter((entry) => typeof entry === 'string' && entry.trim())
            : []
    }
    catch(error) {
        return [value]
    }
}

const state = {
    currentPartType: '',
    attribs: {
    },
    filtersSortHub:  {
        cpu:            {brand:      ['AMD', 'Intel'],               Number_of_Cores:    ['4 Cores', '6 Cores', '8 Cores'],  RAM_Type:      ['DDR4', 'DDR3']},
        motherboard:    {socket:     ['AM4', 'LGA1156', 'LGA1155'],  RAM_Type:           ['DDR4', 'DDR3']},
        ram:            {capacity:   ['16GB', '32GB', '8GB'],        RAM_Type:           ['DDR4', 'DDR3']},
        storage:        {type:       ['SSD', 'HDD'],                 compat_interface:   ['SATA', 'NVME', 'M.2 SATA'],       Capacity: ['4TB', '8TB']},
        graphics:       {graphics_processor: ['GeForce', 'RadeOn'],  graphics_ram_capacity: ['8GB'],                         memory_bus_width: ['256 bit', '192 bit'], },
        psu:            {form_factor:['ATX'],                        wattage:            ['600W', '1200W'],                  brand:    ['EVGA', 'Corsair']},
        case:           {form_factor:['ATX', 'miniATX', 'microATX'], material:           ['Tempered Glass']},
    },
    filtersHub:  {
        cpu:            ['AMD', 'Intel', '4 Cores', '6 Cores', '8 Cores','DDR4', 'DDR3'],
        motherboard:    ['AMD', 'Intel', 'AM4', 'LGA1156', 'LGA1155', 'DDR4', 'DDR3'],
        ram:            ['16GB', '32GB', '8GB', 'DDR4', 'DDR3'],
        storage:        ['SSD', 'HDD', 'SATA', 'NVME', 'M.2 SATA', '2TB', '1TB'],
        graphics:       ['GeForce', 'RadeOn', 'RTX2060', 'nVidia', 'ATI', '8GB', '256bit', '192bit'],
        psu:            ['ATX', '600W', '1200W', 'EVGA', 'Corsair'],
        case:           ['ATX', 'Tempered Glass', 'miniATX', 'microATX'],
    },
    searchFilters: null,
    processors: {
        attribs: { // Attribs are used to display keys in specifications list
            general: generalFields([
                "asin",
                "type",
                "model",
                "usability",
                "benchmark",
                "chosen",
                "description",
                "amzn_price",
                "amzn_link"
            ]),
            specifications: [
                "Core Frequency",
                "Turbo Frequency",
                "Number of Cores",
                "Number of Threads",
                "Generation",
                "Compatible Memory",
                "Bus Speed",
                "Socket",
                "Cache Memory",
                "Max Memory Size",
                "ECC Support",
                "Hyper-Threading",
                "Turbo Boost",
                "TDP",
                "CPU-Z Benchmark",
            ],
            compats: [
                "brand",
                "socket",
                "chipset",
                "motherboard",
                "ram",
                "ram_speed",
                "processor_generation",
                "tdp"
            ]
        },
    },
    motherboards: {
        attribs: {
            general: generalFields([
                "asin",
                "type",
                "brand",
                "model",
                "usability",
                "description",
                "form_factor",
                "amzn_price",
                "amzn_link"
            ]),
            specifications: [
                "Compatible Memory",
                "Bus Speed",
                "Socket",
                "WiFi",
                "Integrated_Graphics",
                "USB",
                "Max Memory Size",
                "ECC Support"
            ],
            compats: [
                "brand",
                "processor_generation",
                "socket",
                "chipset",
                "m_2",
                "M_2_Slot",
                "ram",
                "ram_speed",
                "ram_slots",
                "form_factor",
                "pci_e",
                "sata_slots",
                "sata_speed",
                "pci_e_slots",
                "tdp",
                "nvme",
                'pci_e_x1',
                'pci_e_x4',
                'pci_e_x8',
                'pci_e_x16',
                'cpu_brand',
            ],
        },
    },
    ram: {
        attribs: { // Attribs are used to display keys in specifications list
            general: generalFields([
                "asin",
                "type",
                "model",
                "brand",
                'number_of_items',
                "description",
                "amzn_price",
                "amzn_link"
            ]),
            specifications: [
                "Capacity",
                "RAM_Speed",
                "RAM_Type",
                "ECC",
                "Pins",
                "Number_of_Sticks",
            ],
            compats: [
                "number_of_items",
                "ram_type",
                "capacity",
                "ram_speed",
                "Pins",
                "ECC",
                "TDP"
            ]
        },
    },
    storage: {
        attribs: { // Attribs are used to display keys in specifications list
            general: generalFields([
                "asin",
                "type",
                "brand",
                "model",
                'number_of_items',
                "description",
                "amzn_price",
                "amzn_link"
            ]),
            specifications: [
                "Disk_Type",
                "Capacity",
                "size",
                "hardware_interface",
                "data_transfer_rate",
                "read_speed",
                "write_speed",
            ],
            compats: [
                "compat_interface",
                "size",
                "speed",
                'tdp'
            ]
        },
    },
    gpus: {
        attribs: { // Attribs are used to display keys in specifications list
            general: generalFields([
                "asin",
                "type",
                "model",
                'brand',
                'number_of_items',
                "description",
                "amzn_price",
                "amzn_link"
            ]),
            specifications: [
                "graphics_processor",
                "GPU_clock_speed",
                "graphics_ram_type",
                "graphics_ram_capacity",
                "memory_bus_width",
                "memory_clock_speed",
                "memory_transfer_speed",
                "graphics_interface",
                "connections",
                "power_consumption",
                "VR",
            ],
            compats: [
                "graphics_interface",
                "psu",
                "form_factor",
                "power_connector",
                "tdp"
            ]
        },
    },
    psus: {
        attribs: { // Attribs are used to display keys in specifications list
            general: generalFields([
                "asin",
                "type",
                "model",
                "brand",
                "number_of_items",
                "description",
                "amzn_price",
                "amzn_link"
            ]),
            specifications: [
                "wattage",
                "modular",
                "eco_mode",
                "energy_rating",
            ],
            compats: [
                "wattage",
                "form_factor",
            ]
        },
    },
    cases: {
        attribs: { // Attribs are used to display keys in specifications list
            general: generalFields([
                "asin",
                "type",
                "model",
                'brand',
                "number_of_items",
                "description",
                "amzn_price",
                "amzn_link"
            ]),
            specifications: [
                "tempered_glass",
                "form_factor",
                "dimentions",
                "weight",
                "I_O_ports",
                "expansion_slots",
                "color",
            ],
            compats: [
                "form_factor",
            ]
        },
    },
    accessories: {
        attribs: { // Attribs are used to display keys in specifications list
            general: [
                "asin",
                "type",
                "model",
                "benchmark",
                'usability',
                "description",
                // "features",
                "amzn_price",
                "amzn_link"
            ],
            specifications: [
                "CPU-Z Benchmark",
                "Core Frequency",
                "Number of Cores",
                "Number of Threads",
                "Generation",
                "Compatible Memory",
                "Bus Speed",
                "Socket",
                "Cache Memory",
                "Max Memory Size",
                "ECC Support",
                "Hyper-Threading",
                "Turbo Boost",
                "TDP",
            ],
            compats: [
                "brand",
                "socket",
                "chipset",
                "motherboard",
                "ram",
                "ram speed",
            ]
        },
    },
    item:null,
    itemLoaded: false,
    items: null,
    itemsLoaded: false,
    message: '',
    loading: false,
    layout: 'demo',
    maxScores: {},
    sortBy: [
        {
            id: 1,
            name: "Price: Low to High",
            chosen: SHOW_PRICES
        },
        {
            id: 2,
            name: "Price: High to Low",
            chosen: false
        },
        {
            id: 3,
            name: "Perf/$: High to Low",
            chosen: false
        },
        {
            id: 6,
            name: "Perf/$: Low to High",
            chosen: false
        },
        {
            id: 4,
            name: "Performance: Low to High",
            chosen: false
        },
        {
            id: 5,
            name: "Performance: High to Low",
            chosen: !SHOW_PRICES
        },
    ],
};

const getters = {
    getSortBy:              (state) => state.sortBy,
    getMaxScores:           (state) => state.maxScores,
    getFiltersSortHub:      (state) => state.filtersSortHub,
    getSearchFilters:       (state) => state.searchFilters,
    getPartLoading:         (state) => state.loading,
    getMessage:             (state) => state.message,
    getAttribs:             (state) => state.attribs,
    getCurrentPartType:     (state) => state.currentPartType,
    getItems:               (state) => {         
            switch(store.getters.lastRoute.replace(/\\|\/builder\//g,'') ) {
                case 'cpu':
                    return state.processors;
                case 'motherboard':
                    return state.motherboards;
                case 'ram':
                    return state.ram;
                case 'storage':
                    return state.storage;
                case 'graphics' || 'gpu' || 'gpus':
                    return state.gpus;
                case 'psu':
                    return state.psus;
                case 'case':
                    return state.cases;
                case 'accessories':
                    return state.accessories;

                default:
            }
    },
    getItem:                (state) => state.item,
    getItemLoaded:          (state) => state.itemLoaded,
    getFetchedItems:        (state) => state.items,
    allProcessors:          (state) => state.processors,
    allMotherboards:        (state) => state.motherboards,
    allRam:                 (state) => state.ram,
    allStorage:             (state) => state.storage,
    allGpus:                (state) => state.gpus,
    allPsus:                (state) => state.psus,
    allCases:               (state) => state.cases,
    allAccessories:         (state) => state.motherboards,
    allItemsLoaded:         (state) => state.itemsLoaded,
    getLayout:              (state) => state.layout,
};

const actions = {
    updateSortBy({commit}, value){
        commit('UPDATE_SORT_BY', value)
    },
    setLayout               ({commit}, layout){
        commit('UPDATE_LAYOUT', layout)
        console.log('layout changed to ', layout)
    },
    clearSavedForm          (_, type){
        localStorage['saved'+type+'Form'] = ''
        console.log(type +' form cleared')
    },
    setSearchFilters        ({commit}, type){
        commit('RECORD_SEARCH_FILTER', type)
    },
    async addItem           ({commit}, postData){
        commit('LOADING_TRUE')
        commit('UPDATE_MESSAGE', 'Processing...')
        console.log("ADD ITEM FROM STORE, sending ", postData)
        return await axios({
            url: `${apiDomain}additem`, 
            method: "post",
            headers: {
              'Content-Type': `application/json`,
              'Authorization': `Bearer ${localStorage.usertoken}`,
              'alg': "HS256",
              'typ': "JWT"
            },
            data: postData
          }).then((response) => {
            var message = 'Item Updated Successfully! Redirecting...'
            console.log('ADD ITEM response ', response)
            commit('UPDATE_MESSAGE', message)
            store.dispatch('clearSavedForm', postData.type)
            commit('ITEMS_LOADED_FALSE')
            setTimeout(() => {
                commit('LOADING_FALSE')
                router.push({path: '/users/items-controller/items?type='+postData.type}).catch(()=>{});
                store.dispatch('fetchItems', postData.type)
              }, 1500);
            return response;
          }, (error) => {
              console.log(postData)
              store.dispatch('setError', error)
              commit('UPDATE_MESSAGE', 'Error, see console for details');
              setTimeout(() => {
                commit('LOADING_FALSE')
              }, 6000);
            console.log(error)
          })
    },
    async editItem          ({commit}, postData){
        commit('LOADING_TRUE')
        commit('UPDATE_MESSAGE', 'Processing...')
        return await axios({
            url: `${apiDomain}update`, 
            method: "put",
            headers: {
              'Content-Type': `application/json`,
              'Authorization': `Bearer ${localStorage.usertoken}`,
              'alg': "HS256",
              'typ': "JWT"
            },
            data: postData
          }).then(async (response) => {
              console.log('EDIT ITEM response ', response)
              store.dispatch('setCurrentPartType', response.data.part[0].type)
              await store.dispatch('fetchItems', response.data.part[0].type)
              var message = 'Item Updated Successfully! Redirecting...'
              commit('UPDATE_MESSAGE', message)
              setTimeout(() => {
                commit('LOADING_FALSE')
                router.push({path: '/users/items-controller/items?type='+response.data.part[0].type}).catch(()=>{});
              }, 1500);
            // console.log('edit successful')
            return response;
          }, (error) => {
            //   console.log(postData)
            store.dispatch('setError', error)
              commit('UPDATE_MESSAGE', 'Error, see console for details');
              commit('ITEMS_LOADED_FALSE')
              setTimeout(() => {
                commit('LOADING_FALSE')
                                router.push({path: '/users/items-controller/items?type='+postData.type}).catch(()=>{});
              }, 1500);
            console.error(error)
          })
    },
    async addPart           ({commit}){
        commit('createProcessor')
    },
    setPartAttribs          ({commit}){
        commit('setAttribs')
    },
    setCurrentPartType      ({commit}, type){
        if(type && type !== ''){
            type = type.toLowerCase()
        }
        localStorage.setItem('currentPartType', type)
        commit('updateCurrentType', type)
    },
    async fetchItems        ({commit}, payload){
        var type = typeof payload == 'object' && payload !== null ? payload.type : payload
        var includeArchived = !!(typeof payload == 'object' && payload !== null && payload.includeArchived)
        console.log("FETCH ITEMS FIRED", type, includeArchived ? 'with archived' : '')
        // console.log("got type ", type)
        if(state.currentPartType == 'gpu'){
            commit('updateCurrentType', 'graphics')
        }
        if(type == 'gpu'){
            commit('updateCurrentType', 'graphics')
        }
        commit('ITEMS_LOADED_FALSE')
        var resolvedType = type ? type : state.currentPartType
        var query = `type=${encodeURIComponent(resolvedType)}`
        if(includeArchived){
            query += '&includeArchived=1'
        }
        return await axios ({
            url: `${apiDomain}items?${query}`,
            method: "get",
        }).then(async (response) => {
            //process main image
            var partsList = response.data.partslist.map((itme) => {
                var images = parsedImageList(itme.imgUrl)
                itme.mainImg = images.find((image) => image.indexOf('<a href') === -1) || ''
                return itme
            })
            console.log('FETCHING ITEMS', partsList)
            
            await store.dispatch('sortItems', {option: resolveSortOption(localStorage.sortBy ? JSON.parse(localStorage.sortBy) : defaultSortOption()), items: partsList})
            commit('ITEMS_LOADED_TRUE')
            commit('UPDATE_MESSAGE', '')
        }, () => {
            commit('UPDATE_MESSAGE', 'Could not load...');
            commit('ITEMS_LOADED_TRUE')
        })
    },
    async setChosen         ({ commit }, item){
        commit('selectItem', item);
    },
    setItems                (_, items){
        console.log('SETTING ITEMS', items)
        store.dispatch('sortItems', {option: resolveSortOption(localStorage.sortBy ? JSON.parse(localStorage.sortBy) : defaultSortOption()), items: items})
    },
    setItem                 ({commit}, item){
        commit('SET_ITEM', item)
        commit('ITEM_LOADED_TRUE')
    },
    unsetItem                 ({commit}){
        commit('UNSET_ITEM')
        commit('ITEM_LOADED_FALSE')
    },
    itemsLoaded({commit}, bool){
        if(bool == false){
            commit("ITEMS_LOADED_FALSE")
        }
        else if(bool == true){
            commit("ITEMS_LOADED_TRUE")
        }
    },
    async deletePart        ({commit}, data){
        return await axios({
          url: `${apiDomain}single`, 
          method: 'delete',
          headers: {
            'Content-Type': `application/json`,
            'Authorization': `Bearer ${localStorage.usertoken}`,
            'alg': "HS256",
            'typ': "JWT"
          },
          data: JSON.stringify(data)
        }).then((response) => {
          return response;
        }, (error) => {
          commit('NEW_ERROR', error)
        })
    },
    sortItems({commit, state},{option, items}){
        if(option && items){
            var result = []
            if(items && typeof(items) == 'string'){
                result = [...JSON.parse(items)]
            }
            else if(items && typeof(items) == 'object'){
                result = [...items]
            }
            option = resolveSortOption(option)
            var sortOptions = [...state.sortBy]
            for (var i = 0; i<sortOptions.length; i++){
                if(option.name == sortOptions[i].name){
                    sortOptions[i].chosen = true;
                }
                else {
                    sortOptions[i].chosen = false
                }
            }
            commit('UPDATE_SORT_BY', sortOptions)
            var scoreContext = scoreSortContext(result)
            // option.chosen = true;
            switch(option.name){
                case ('Price: Low to High'):
                    result.sort((a, b) => compareByMetric(a, b, (item) => functions.parsePrice(item.amzn_price), 'asc'))
                    localStorage.sortBy = JSON.stringify(option)
                    break;
                case ('Price: High to Low'):
                    result.sort((a, b) => compareByMetric(a, b, (item) => functions.parsePrice(item.amzn_price), 'desc'))
                    localStorage.sortBy = JSON.stringify(option)
                    break;
                case ('Perf/$: Low to High'):
                    result.sort((a, b) => compareByMetric(a, b, (item) => valueSortValue(item, scoreContext), 'asc'))
                    localStorage.sortBy = JSON.stringify(option)
                    break;
                case ('Perf/$: High to Low'):
                    result.sort((a, b) => compareByMetric(a, b, (item) => valueSortValue(item, scoreContext), 'desc'))
                    localStorage.sortBy = JSON.stringify(option)
                    break;
                case ('Performance: Low to High'):
                    result.sort((a, b) => compareByMetric(a, b, (item) => performanceSortValue(item, scoreContext), 'asc'))
                    localStorage.sortBy = JSON.stringify(option)
                    break;
                case ('Performance: High to Low'):
                    result.sort((a, b) => compareByMetric(a, b, (item) => performanceSortValue(item, scoreContext), 'desc'))
                    localStorage.sortBy = JSON.stringify(option)
                    break;                
            }
            commit('assigningItems', result)
        }
    },
};

const mutations = {
    UPDATE_SORT_BY(state, value){
        state.sortBy = [...value]
    },
    SET_MAX_SCORE(state, {type, score}){
        state.maxScore[type] = score
    },
    RECORD_SEARCH_FILTER    (state, type){
        state.searchFilters = state.filtersHub[type]
    },
    UPDATE_LAYOUT           (state, layout){
        state.layout = layout
    },
    LOADING_TRUE            (state){
        state.loading = true
    },
    LOADING_FALSE           (state){
        state.loading = false
    },
    UPDATE_MESSAGE          (state, newMessage){
        state.message = newMessage
    },
    ITEMS_LOADED_TRUE       (state){
        state.itemsLoaded = true
    },
    ITEMS_LOADED_FALSE      (state){
        state.itemsLoaded = false
    },
    ITEM_LOADED_TRUE        (state){
        state.itemLoaded = true
    },
    ITEM_LOADED_FALSE        (state){
        state.itemLoaded = false
    },
    SET_ITEM                (state, item){
        state.item = item
        // console.log('item is set!')
    },
    UNSET_ITEM              (state){
        state.item = null
    },
    createPart:             (state) => {
        return new Promise(async (resolve, reject) => {
            try {
              const { data } = await axios.post(addItemUrl, state.attribs)
            //   console.log(data)
              resolve(data)
            }catch(e){
                // console.error(e)
              reject(e)
            }
          })
    },
    updateCurrentType:      (state, type) => {
        // console.log('received '+ type)
        state.currentPartType = type
    },
    assigningItems:         (state, items) => {
        if(items){
            var localItems = cloneDeep(items)

            // Compatibility side-effect (retained from the previous implementation).
            localItems.forEach((item) => {
                if(item && item.type && item.specs && item.compat){
                    functions.createCompatTable({build: store.getters.allMenuOptions, checkItem: item})
                }
                if(item){ item['compatible'] = false }
            })

            // Performance via the etalon (src/perf.js): raw capacity -> per-type
            // ceiling -> normalized 0-100. localItems is a single part type, so the
            // ceiling is that type's strongest part (which lands at 100). The
            // category source-consistency guard keeps the CPU benchmark spine from
            // distorting scores when CPU_Z_Benchmark is sparse/dirty.
            var ignoreBenchmark = perf.shouldIgnoreBenchmark(localItems)
            var ceiling = perf.buildCeiling(localItems, { ignoreBenchmark: ignoreBenchmark })
            // Value (performance per dollar) ceiling = the best capacity/price ratio
            // in this type. valueIndex below is computed from the scraped price for
            // RANKING only; the price itself stays hidden when SHOW_PRICES is off.
            var valueCeiling = perf.buildValueCeiling(localItems, { ignoreBenchmark: ignoreBenchmark })
            var scoredTypes = {}
            localItems.forEach((item) => {
                if(!item || !item.type){ return }
                var cap = perf.rawCapacity(item, { ignoreBenchmark: ignoreBenchmark })
                item['performance'] = cap ? perf.normalizedScore(cap.raw, ceiling) : 0
                item['valueIndex'] = perf.valueIndex(item, valueCeiling, { ignoreBenchmark: ignoreBenchmark })
                scoredTypes[item.type] = true
            })
            // The top part of the type normalizes to 100; List/Slider read this so
            // their bars/scores are the etalon's normalized capacity.
            Object.keys(scoredTypes).forEach((type) => { state.maxScores[type] = 100 })

            state.items = [...localItems]
        }
    },
    selectItem:             (state, item) => {
        for(var i =0; i<state.items.length; i++){
            state.items[i].chosen = false;
            if(state.items[i] == item){
                state.items[i].chosen = true
                item.chosen = true;
            }
        } 
    },
    setAttribs:             (state) => {
        switch(state.currentPartType.toLowerCase() ) {
            case 'cpu':
                state.attribs = state.processors.attribs
                // console.log('cpu attribs assigned', state.attribs)
                return state.processors;
            case 'motherboard':
                state.attribs = state.motherboards.attribs
                // console.log('MB attribs assigned', state.attribs)
                return state.motherboards;
            case 'ram':
                state.attribs = state.ram.attribs
                // console.log('ram attribs assigned', state.attribs)
                return state.ram;
            case 'storage':
                state.attribs = state.storage.attribs
                // console.log('storage attribs assigned', state.attribs)
                return state.storage;
            case 'graphics' || 'gpu':
                state.attribs = state.gpus.attribs
                // console.log('gpu attribs assigned', state.attribs)
                return state.gpus;
            case 'psu':
                state.attribs = state.psus.attribs
                // console.log('psu attribs assigned', state.attribs)
                return state.psus;
            case 'case':
                state.attribs = state.cases.attribs
                // console.log('cases attribs assigned', state.attribs)
                return state.cases;
            case 'accessories':
                state.attribs = state.accessories.attribs
                // console.log('accessories attribs assigned', state.attribs)
                return state.accessories;
            default:
        }
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}
